import SEOHead from "@/components/base/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import FeaturedArticles from "./components/FeaturedArticles";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

const homeSEO = {
  title: "成人影院——专业私密观影体验指南 | 私享观影指南",
  description: "成人影院是专为成年人提供私密、舒适观影环境的专业场所。本页详细介绍成人影院的选择标准、观影礼仪、隐私保护及合规运营知识，帮助成年用户了解相关信息，做出明智选择。",
  keywords: "成人影院,成人影院选择指南,私密观影体验,成人影院礼仪,合规成人影院,成人影院隐私保护,成人影院常见问题",
  ogType: "website",
};

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "私享观影指南",
  url: "https://privatecinema-guide.com",
  description: "专业私密观影体验指南，为成年人提供成人影院选择标准、观影礼仪、隐私保护及合规运营知识。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://privatecinema-guide.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "私享观影指南",
  url: "https://privatecinema-guide.com",
  description: "专业成人影院资讯与评测平台",
  contactPoint: {
    "@type": "ContactPoint",
    email: "contact@privatecinema-guide.com",
    telephone: "400-888-9999",
    contactType: "customer service",
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        {...homeSEO}
        schemaJson={{ ...homeSchema, ...orgSchema }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedArticles />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}